import React from 'react';
import { observer } from 'mobx-react';
import { Drawer } from 'antd';
import { useStore } from '../../../app/data/root.store';
import { EntitiesListPanel } from './EntitiesListPanel';
import { EntityDetailPanel } from './EntityDetailPanel';
import { EntitiesPanelModal } from './EntitiesPanelModal';
import { EntitiesPanelDrawerWrapper, EntityPanelWrapper, AnimatedPanelContainer } from './EntitiesPanel.styles';

export const EntitiesPanel = observer((props) => {
    const { uiStore } = useStore();
    const { showEntityDetail, selectedEntity, handleBackToList, handleEditEntity, handleDeleteEntity, entities, selectedEntityId, handleEntitySelect, handleAddEntity, isOpen, onClose } = props;

    const isModalMode = !uiStore.isEntitiesPageThreshold && uiStore.isDesktopView;

    if (isModalMode) {
        return (
            <EntitiesPanelModal
                showEntityDetail={showEntityDetail}
                selectedEntity={selectedEntity}
                handleBackToList={handleBackToList}
                handleEditEntity={handleEditEntity}
                handleDeleteEntity={handleDeleteEntity}
                entities={entities}
                selectedEntityId={selectedEntityId}
                handleEntitySelect={handleEntitySelect}
                handleAddEntity={handleAddEntity}
                isOpen={isOpen}
                onClose={onClose}
            />
        );
    }

    // If we're in the entities page threshold (desktop layout), show as side panel
    if (uiStore.isEntitiesPageThreshold) {
        return (
            <EntityPanelWrapper>
                <AnimatedPanelContainer isVisible={showEntityDetail && selectedEntity}>
                    {showEntityDetail && selectedEntity && (
                        <EntityDetailPanel
                            entity={selectedEntity}
                            onBack={handleBackToList}
                            onEdit={handleEditEntity}
                            onDelete={handleDeleteEntity}
                        />
                    )}
                </AnimatedPanelContainer>
                
                <AnimatedPanelContainer isVisible={!showEntityDetail || !selectedEntity}>
                    <EntitiesListPanel
                        entities={entities}
                        selectedEntityId={selectedEntityId}
                        onEntitySelect={handleEntitySelect}
                        onAddEntity={handleAddEntity}
                        onEditEntity={handleEditEntity}
                        onDeleteEntity={handleDeleteEntity}
                    />
                </AnimatedPanelContainer>
            </EntityPanelWrapper>
        );
    }

    // Mobile view or desktop non-threshold - show as full screen drawer
    const handleClose = () => {
        onClose?.();
        if (showEntityDetail) {
            handleBackToList();
        }
    };

    return (
        <Drawer
            closable={false}
            visible={isOpen}
            width="100%"
            className="entities-panel-drawer-mobile"
            placement="right"
            destroyOnClose={true}
            push={false}
            onClose={handleClose}
        >
            <EntitiesPanelDrawerWrapper>
                {showEntityDetail && selectedEntity ? (
                    <EntityDetailPanel
                        entity={selectedEntity}
                        onBack={handleBackToList}
                        onEdit={handleEditEntity}
                        onDelete={handleDeleteEntity}
                    />
                ) : (
                    <EntitiesListPanel
                        entities={entities}
                        selectedEntityId={selectedEntityId}
                        onEntitySelect={handleEntitySelect}
                        onAddEntity={handleAddEntity}
                        onEditEntity={handleEditEntity}
                        onDeleteEntity={handleDeleteEntity}
                        onClose={handleClose}
                    />
                )}
            </EntitiesPanelDrawerWrapper>
        </Drawer>
    );
});